import moment from "moment";

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace momentUtil{

export class DateTimeHelper {
    currentTime: moment.Moment;

    constructor() {
        this.currentTime = moment();
    }

    public getTimeStamp(){
        return new Date().getTime();
    }



    public now() {
        this.currentTime = moment();
        return this;

    }
    public toIsoString(keepOffset:boolean=true){
        return this.currentTime.toISOString(keepOffset);
    }

    public addMinutes(minutes:number){
        this.currentTime.add(minutes, "minutes");
        return this;
    }
    public addHours(hours:number){
        this.currentTime.add(hours,"hours");
        return this;
    }
    public addDays(days:number){
        this.currentTime.add(days,"days");
        return this;
    }
}

export const dateTime=new DateTimeHelper();
}